import { useEffect, useState } from 'react';
import { Menu } from 'semantic-ui-react';
import { useHistory, useLocation } from 'react-router-dom';

const CollaboMenu = () => {
  const [pathname, setPathname] = useState('');
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    setPathname(location.pathname);
  }, [location]);

  const menus = [
    { text: '블랙리스트 관리 (체험단)', value: '/collabo/blacklist' },
    { text: '제휴 어드민 유저 목록', value: '/collabo/admin' },
    { text: '정산 관리', value: '/settlement' },
  ];

  const _click = (menu) => {
    history.push(menu.value);
  };

  return (
    <Menu fluid secondary vertical>
      {menus.map((menu) => (
        <Menu.Item
          key={menu.value}
          active={menu.value === pathname}
          onClick={() => _click(menu)}
        >
          {menu.text}
        </Menu.Item>
      ))}
    </Menu>
  );
};

export default CollaboMenu;
